<template>
<!--<div>{{groupOption}}</div>-->
</template>

<script>
    export default {
        name: "groupType",
        props:{
            questionGroupText:{
                type: String,
            }
        },
        data() {
            return {
                groupOption: []
            }
        },
      mounted() {
            this.getGroupType()
        },
        methods: {
            //查询分类集合
            getGroupType(){
                this.$request.post("/grow/theme/getgrouptype").then( r => {
                    this.groupOption = r
                    this.$emit("abdd", this.groupOption);
                })
            }
        }
    }

</script>

<style scoped>

</style>
